import { CallMethodEnums } from '@/types/api';
import { ReportsApiRes } from '@/types/reports';

import { call } from './utils';

export const reportsGet = async(): Promise<ReportsApiRes> => {
  const json = call<unknown, ReportsApiRes>( {
    isProtected: true,
    method: CallMethodEnums.GET,
    route: '/api/reports'
  } );

  return json;
};
